import { Routes, Route } from 'react-router-dom';
import { VendorsListPage } from './vendors-list-page';
import { VendorCreatePage } from './vendor-create-page';
import { VendorDetailPage } from './vendor-detail-page';

export function VendorsPage() {
  return (
    <Routes>
      <Route index element={<VendorsListPage />} />
      <Route path="new" element={<VendorCreatePage />} />
      <Route path=":id" element={<VendorDetailPage />} />
    </Routes>
  );
}
